import { render, staticRenderFns } from "./CopyVenue.vue?vue&type=template&id=019b7202"
import script from "./CopyVenue.vue?vue&type=script&lang=ts"
export * from "./CopyVenue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports